// extracted by mini-css-extract-plugin
export var bubble = "_2l-0";
export var container = "_2l-f";
export var contrastBorder = "_2l-g";
export var greyOut = "_2l-2";
export var initialsColor0 = "_2l-3";
export var initialsColor1 = "_2l-4";
export var initialsColor10 = "_2l-d";
export var initialsColor11 = "_2l-e";
export var initialsColor2 = "_2l-5";
export var initialsColor3 = "_2l-6";
export var initialsColor4 = "_2l-7";
export var initialsColor5 = "_2l-8";
export var initialsColor6 = "_2l-9";
export var initialsColor7 = "_2l-a";
export var initialsColor8 = "_2l-b";
export var initialsColor9 = "_2l-c";
export var initialsWrapper = "_2l-1";
export var large = "_2l-l";
export var medium = "_2l-k";
export var mediumSmall = "_2l-j";
export var mediumSmallMedium = "_2l-o";
export var micro = "_2l-h";
export var small = "_2l-i";
export var tiny = "_2l-n";
export var xTiny = "_2l-m";